// extracted by mini-css-extract-plugin
export const description = "dream-team-module--description--2fEZZ";
export const staffContainer = "dream-team-module--staffContainer--33Bq_";
export const staffCard = "dream-team-module--staffCard--2XV6e";
export const staffImage = "dream-team-module--staffImage--1jrDN";
export const staffName = "dream-team-module--staffName--3UC4e";
export const staffTitle = "dream-team-module--staffTitle--2EUGY";